import React from "react";
import PropTypes from "prop-types";
import ContractGenerationContainer from "../../../../document/edit/contractGeneration/components/ContractGenerationContainer";
import FolderCommentsCardContainer from "features/folder/edit/comments/components/FolderCommentsCardContainer";

const FolderContractGenerationContainer = ({ documentId, siteId }) => {
  return (
    <>
      <ContractGenerationContainer documentId={documentId} siteId={siteId} />
      <FolderCommentsCardContainer documentId={documentId} siteId={siteId} />
    </>
  );
};

FolderContractGenerationContainer.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired
};

export default FolderContractGenerationContainer;
